import { createSelector, createSlice } from '@reduxjs/toolkit';
import _isNil from 'lodash/isNil';
import { IUser } from '@Data/users/Interfaces';
import { RootState } from '@Services/redux/Store';
import { ITeam } from './Interfaces';
import { ITeamState, initialTeamState } from './State';

const TeamSlice = createSlice({
    name: 'Team',
    initialState: initialTeamState,
    reducers: {
        updateTeams(state, action) {
            state.teams = action.payload;
        },
        setSelectedTeam(state, action) {
            state.selectedTeam = action.payload;
        },
        updateTeamMembers(state, action) {
            state.teamMembers = action.payload;
        },
        updateTeamMembersInDepartment(state, action) {
            state.teamMembersInDepartment = action.payload;
        },
        clearTeams() {
            return initialTeamState;
        },
    },
});

export const TeamActions = TeamSlice.actions;
export const teamsState = (state: RootState): Array<ITeam> => state.team.teams;
export const activeTeamsState = createSelector(teamsState, (teams) => {
    return _isNil(teams) ? teams : teams.filter((t) => t.is_active);
});
export const selectedTeamState = (state: RootState): ITeam =>
    state.team.selectedTeam;
export const teamMembersState = (state: RootState): Array<IUser> =>
    state.team.teamMembers;

export const teamMembersInDepartmentState = (state: RootState): Array<IUser> =>
    state.team.teamMembersInDepartment;

export default TeamSlice.reducer;
